module.exports = __webpack_public_path__ + "img/37.3.TP.23bfcdca.png";